import React, { useRef, useState, useEffect } from 'react';
import cn from 'classnames';
import * as PropTypes from 'prop-types';
import { createPortal } from 'react-dom';
import { useBlockScroll } from '../../hooks/useBlockScroll';
import { CSSTransition } from 'react-transition-group';
import { useCoreCategories } from '../../hooks/useCoreCategories';
import { useAuth0 } from '../../context/auth0';

import { ModalCustomerSignup } from '../modals';
import SmartSearchTermsAutocomplete from '../SearchForm/SmartSearchTermsAutocomplete';
import HistoryList from '../HistoryList';
import LanguagesDropdownMobile from './LanguagesDropdownMobile';
import { useClickEventOnDocument } from '../../hooks/useClickEventOnDocument';
import pages from '../../define/pages';
import endpoints from '../../define/endpoints';
import { ROLES, QUERY_PARAMS } from '../../../constants';

import Icon from '@iconify/react';
import iconCompass from '@iconify-icons/mdi/compass-outline';
import iconHeart from '@iconify-icons/mdi/heart-outline';
import iconHistory from '@iconify-icons/mdi/history';
import iconAccount from '@iconify-icons/mdi/account-circle';
import iconPhone from '@iconify-icons/mdi/phone';
import iconPartner from '@iconify-icons/mdi/shield-account';
import iconTicket from '@iconify-icons/mdi/ticket-confirmation-outline';
import iconLogout from '@iconify-icons/mdi/location-exit';
import iconGlobe from '@iconify-icons/mdi/globe';
import Avatar, { AvatarSizes } from '../Avatar/Avatar';

let language_fullname = 'Italiano';
freedomeConfig.languages.map((language, index) => {
  if (language.code == freedomeConfig.locale)
    language_fullname = language.fullname;
});

const SmartViewMobile = (props) => {
  const categories = useCoreCategories();
  const { isAuthenticated, isLoading, loginWithRedirect, logout, user } =
    useAuth0();

  useBlockScroll(props.isOpen);

  const formRef = useRef(null);
  const [selectedSearchTerm, setSelectedSearchTerm] = useState(
    props.initialSearchTerm
  );
  const handleSearchTermChange = (searchTermObj) => {
    setSelectedSearchTerm(searchTermObj.title);
  };

  const transitionProps = {
    classNames: 'navigation-menu-mbl',
    in: props.isOpen && !isLoading,
    mountOnEnter: true,
    unmountOnExit: true,
    appear: true,
    timeout: 200,
  };
  const [isLanguagesDropdownOpen, setIsLanguagesDropdownOpen] =
    React.useState(false);
  useClickEventOnDocument([isLanguagesDropdownOpen], () => {
    isLanguagesDropdownOpen && setIsLanguagesDropdownOpen(false);
  });
  useEffect(() => {
    if (selectedSearchTerm) {
      formRef.current.submit();
    }
  }, [selectedSearchTerm]);

  return createPortal(
    <CSSTransition {...transitionProps}>
      <div className={cn('navigation-menu-mbl')}>
        <div className={cn('navigation-menu-mbl__header')}>
          <div className="navbar__logo">
            <img
              src={endpoints.bucket + 'images/new/logo-freedome-white.svg'}
              alt="Freedome"
            />
          </div>
          <div
            className={'navigation-menu-mbl__header__close'}
            onClick={props.onClickClose}
          />
        </div>

        <div className={cn('navigation-menu-mbl__body')}>
          <form
            ref={formRef}
            className={'region-form'}
            action={pages.catalogue}
            method={'get'}
          >
            <div
              className={cn('search-section__location-input', {
                'search-section__location-input--icon-primary':
                  !!selectedSearchTerm,
              })}
            >
              <SmartSearchTermsAutocomplete
                selectedSearchTerm={selectedSearchTerm}
                onSearchTermSelect={handleSearchTermChange}
                selectFirstSuggestionOnBlur={false}
              />
            </div>
          </form>

          {localStorage.getItem('listing-history') && (
            <React.Fragment>
              <a
                href={pages.historyList}
                className={cn('navigation-menu-mbl__body__entry')}
              >
                <Icon icon={iconHistory} className="icon" />{' '}
                {app_main_wpml.search_history}
              </a>

              <HistoryList
                showAsSwiper={true}
                itemClassName="swiper-slide"
                data-gtm-track_impression
                data-item_list_name="history"
              />
            </React.Fragment>
          )}
          <a
            href={pages.catalogue}
            className={cn('navigation-menu-mbl__body__entry')}
          >
            <Icon icon={iconCompass} className="icon" />
            {app_main_wpml.explore_activity}
          </a>
          {categories &&
            categories.map((rootCategory) => {
              return (
                <div key={rootCategory.title} className="category-tree">
                  <h3>{rootCategory.title}</h3>

                  {rootCategory.subContents &&
                    rootCategory.subContents
                      .filter((category) => !!category.slug)
                      .map((category) => {
                        return (
                          <a
                            key={category.slug}
                            href={'/' + category.slug + '/'}
                          >
                            <span className="tag light">{category.title}</span>
                          </a>
                        );
                      })}
                </div>
              );
            })}

          {!!pages.contactUs && (
            <a
              href={pages.contactUs}
              className={cn('navigation-menu-mbl__body__entry')}
            >
              <Icon icon={iconPhone} className="icon" />
              {app_main_wpml.contacts}
            </a>
          )}

          {!!pages.partnership && (
            <a
              href={pages.partnership}
              className={cn('navigation-menu-mbl__body__entry')}
            >
              <Icon icon={iconPartner} className="icon" />{' '}
              {app_main_wpml.became_partner}
            </a>
          )}
          {
            <span
              onClick={() => setIsLanguagesDropdownOpen(true)}
              className={cn(
                'navigation-menu-mbl__body__entry wpml-language-switcher-mobile'
              )}
            >
              <div>
                {' '}
                <Icon icon={iconGlobe} className="icon" />{' '}
                {app_main_wpml.language}{' '}
              </div>
              <span>{language_fullname}</span>
            </span>
          }
          {isAuthenticated && (
            <a
              onClick={logout}
              className={cn('navigation-menu-mbl__body__entry')}
            >
              <Icon icon={iconLogout} className="icon" />
              {app_main_wpml.logut}
            </a>
          )}

          {<LanguagesDropdownMobile isOpen={isLanguagesDropdownOpen} />}
        </div>

        <div className={cn('navigation-menu-mbl__footer')}>
          <div className={cn('navigation-menu-mbl__footer__content')}>
            {!isAuthenticated && (
              <div className="grid-x navigation-menu-mbl__footer__content__buttons">
                <button
                  className={cn(
                    'navigation-menu-mbl__footer__content__btn',
                    'btn',
                    'btn--light'
                  )}
                  onClick={() => {
                    loginWithRedirect();
                  }}
                >
                  {' '}
                  {app_main_wpml.login}{' '}
                </button>

                <ModalCustomerSignup />
              </div>
            )}

            {isAuthenticated && user.role === ROLES.CUSTOMER && (
              <div className="grid-x navigation-menu-mbl__footer__content__icons-nav">
                {!!pages.profile && (
                  <div className="cell auto">
                    <a
                      href={pages.profile}
                      className={cn('navigation-menu-mbl__body__entry')}
                    >
                      {!user.profile_image && (
                        <Icon icon={iconAccount} className="icon" />
                      )}
                      {!!user.profile_image && (
                        <Avatar
                          size={AvatarSizes.xxs}
                          className={'m-auto'}
                          firstName={user && user.first_name}
                          lastName={user && user.last_name}
                          profileImage={user && user.profile_image}
                        />
                      )}

                      {app_main_wpml.profile}
                    </a>
                  </div>
                )}
                {!!pages.orderList && (
                  <div className="cell auto">
                    <a
                      href={pages.orderList}
                      className={cn('navigation-menu-mbl__body__entry')}
                    >
                      <Icon icon={iconTicket} className="icon" />
                      {app_main_wpml.reservations}
                    </a>
                  </div>
                )}
                {!!pages.wishList && (
                  <div className="cell auto">
                    <a
                      href={pages.wishList}
                      className={cn('navigation-menu-mbl__body__entry')}
                    >
                      <Icon icon={iconHeart} className="icon" />
                      {app_main_wpml.favourite}
                    </a>
                  </div>
                )}
              </div>
            )}

            {isAuthenticated && user.role !== ROLES.CUSTOMER && (
              <div className="grid-x grid-padding-x">
                <a
                  href={window.freedomeConfig.endpoints.dashboard}
                  className={cn(
                    'navigation-menu-mbl__footer__content__btn',
                    'btn',
                    'btn--secondary'
                  )}
                >
                  {app_main_wpml.dashboard}
                </a>
              </div>
            )}
          </div>
        </div>
      </div>
    </CSSTransition>,
    document.body
  );
};

SmartViewMobile.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClickClose: PropTypes.func.isRequired,
};

export default SmartViewMobile;
